/**
 * This function will check up the inheritance chain, a better typeof
 * @example
	$_GP._.is('number', 33) // true
	$_GP._.is('number', '33') // false
	$_GP._.is('number', NaN) // false
 * @param {string} str - name to test
 * @param {*} objType - any js object
 * @returns {boolean}
 */
$_GP._.is = function(str, objType) {
	// TODO
	// is('nan', NaN)
	// is('nil', null) > null || undefined

	const types  = 'array object string date regexp function boolean number null undefined symbol'.split(' ')
	const validStr = types.some(t=> str === t)

	if (!validStr) {
		console.error('Error: first argument is not a valid data type.')
		return;
	}

	const type = Object.prototype.toString.call(objType).slice(8, -1).toLocaleLowerCase();

	if (str === 'number' && type === 'number') {
		return objType === objType
	}

	return str === type
}
